import { useState } from 'react';
import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';
import { Button } from '@rsos/base-components';
import Popover from '@rsos/components/capstone/base/Popover';

const StyledButton = styled(Button).attrs(props => ({
  dataName: props.dataName || '',
  color: 'primaryText',
}))`
  padding: 8px;
`;

export const PopoverBox = styled(Box).attrs({
  padding: '10px',
  backgroundColor: 'primaryText',
  borderRadius: '5px',
})``;

export const PopoverText = styled(Text).attrs({
  color: 'background',
  size: 'small',
})``;

const IconButton = ({
  dataName = '',
  disabled,
  onClick,
  size = 'small',
  children,
  tooltip,
}) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);

  const handleHover = isVisible => setIsPopoverVisible(isVisible);
  const handleMouseEnter = () => handleHover(true);
  const handleMouseLeave = () => handleHover(false);

  const button = (
    <StyledButton
      dataName={dataName}
      btnType="secondary"
      disabled={disabled}
      size={size}
      grow={false}
      noMargin
      onClick={onClick}
    >
      {children}
    </StyledButton>
  );

  return (
    <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {tooltip ? (
        <Popover
          cssDisplayProperty="block"
          data-name={dataName}
          isOpen={isPopoverVisible}
          popoverID={dataName}
          trigger={button}
          useCenterXOffset
          yOffset={58}
        >
          <PopoverBox>
            <PopoverText>{tooltip}</PopoverText>
          </PopoverBox>
        </Popover>
      ) : (
        button
      )}
    </Box>
  );
};

export default IconButton;
